<div *ngIf="dataUser || showDetailUser == true" id="userDetail">
	<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
		<section class="container admin-dashboard-details account-details-container">
			<section class="template-section-title">
				<div class="breadcrumb-container">
					<span>Admin <i class="fa fas fa-chevron-right"></i></span>
					<app-breadcrumb [pageName]="'Accounts Details'" [isTopLevel]="true"></app-breadcrumb>
				</div>
				<div class="title-container">
					<h1>Accounts Details</h1>
				</div>
			</section>

			<section class="user-dashboard">
				<div class="user-name">
					<h2 class="user-name" *ngIf="dataUser.firstName || dataUser.lastName">{{dataUser.firstName + " " + dataUser.lastName}}</h2>
					<h2 class="user-name" *ngIf="!dataUser.firstName || !dataUser.lastName">User Name</h2>
					<h6 *ngIf="!dataUser.firstName || !dataUser.lastName">(Apparently, this user has not registered a name.)</h6>
				</div>
				<div class="user-navigation">
					<div class="profile" (click)="openTab($event, 'profile')"
						 [ngClass]="{activeTab:chosenTab=='profile'}">
						<span>Profile</span>
					</div>
					<div class="delegates" (click)="openTab($event, 'delegates')"
						 [ngClass]="{activeTab:chosenTab=='delegates'}">
						<span>Delegates</span>
					</div>
					<div class="plan" (click)="openTab($event, 'plan')" [ngClass]="{activeTab:chosenTab=='plan'}">
						<span>Plan</span>
					</div>
					<div class="activity" (click)="openTab($event, 'activity')"
						 [ngClass]="{activeTab:chosenTab=='activity'}">
						<span>Activity</span>
					</div>
				</div>
			</section>

			<section class="user-data-info">
				<!-- Profile -->
				<section class="tabcontent" id="profile">
					<section class="row info-user-row">
						<div class="col-12 col-sm-3">
							<div class="form-group mail">
								<label for="email">Email</label>
								<div class="user-mail" id="email">
									{{dataUser.email}}
								</div>
							</div>
							<div class="form-group mail">
								<label for="email">Account Created</label>
								<div class="user-mail" id="email">
									{{dataUser.lastUpdate | date: 'dd/MM/yyyy, h:mm a'}}
								</div>
							</div>
							<div class="form-group mail">
								<label for="email">Status</label>
								<div class="user-mail" id="email">
									<!-- Data -->
								</div>
							</div>
						</div>
						<div class="col-12 col-sm-3">
							<div class="form-group license">
								<label for="licenseType">License Type</label>
								<div class="user-license" id="licenseType">
									<!-- Data -->
								</div>
							</div>
							<div class="form-group license">
								<label for="licenseType">Last Log in</label>
								<div class="user-license" id="licenseType">
									<!-- Data -->
								</div>
							</div>
							<div class="form-group license">
								<label for="licenseType">Account Verified</label>
								<div class="user-license" id="licenseType">
									<!-- Data -->
								</div>
							</div>
						</div>
						<div class="col-12 col-sm-3">
							<div class="form-group source">
								<label for="source">Source</label>
								<div class="user-source" id="source">
									<!-- Data -->
								</div>
							</div>
							<div class="form-group source">
								<label for="source">Last Edit</label>
								<div class="user-source" id="source">
									<!-- Data -->
								</div>
							</div>
						</div>
						<div class="col-12 col-sm-3">
							<div class="form-group postcode">
								<label for="postCode">Post Code</label>
								<div class="user-post-code" id="postCode">
									<!-- Data -->
								</div>
							</div>
							<div class="form-group postcode">
								<label for="postCode">Renewal Date</label>
								<div class="user-post-code" id="postCode">
									<!-- Data -->
								</div>
							</div>
						</div>
					</section>
					<section class="row action-account-row">
						<input type="button" class="btn btn-primary back-btn" value="Back" (click)="goBack()">
						<input type="button" class="btn btn-primary" value="Delete Account">
						<input type="button" class="btn btn-primary" value="Reset Password">
					</section>
				</section>
				<!-- Delegates -->
				<section class="tabcontent hide-category" id="delegates">
					<div class="table-responsive admin-dashboard-table">
						<table class="table table-hover">
							<thead>
							<tr>
								<th scope="col">Delegates</th>
								<th scope="col">Relation</th>
								<th scope="col">Email</th>
								<th scope="col">Assets</th>
								<th scope="col">Debts</th>
								<th scope="col">Daily Life</th>
								<th scope="col">Digital Life</th>
								<th scope="col">Wishes</th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td>
									<!-- Data here-->
								</td>
								<td class="unlock-btn">
									<input type="button" class="btn" value="Unlock">
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</section>
				<!-- Plan -->
				<section class="tabcontent hide-category" id="plan">
					<section class="row info-user-row">
						<div class="col-12 col-sm-3">
							<div class="form-group added-items">
								<label for="">Items Added</label>
								<div>
									<!-- Data -->
								</div>
							</div>
						</div>
						<div class="col-12 col-sm-3">
							<div class="form-group added-delegates">
								<label for="">Delegates Added</label>
								<div>
									<!-- Data -->
								</div>
							</div>
						</div>
						<div class="col-12 col-sm-3">
							<div class="form-group next-review-date">
								<label for="">Next review date</label>
								<div>
									<!-- Data -->
								</div>
							</div>
						</div>
						<div class="col-12 col-sm-3">
							<div class="form-group review-status">
								<label for="">Review Status</label>
								<div>
									<!-- Data -->
								</div>
							</div>
						</div>
					</section>
					<section class="row sections-items-row">
						<section class="col-12 col-sm-3">
							<div class="form-group sections-items">
								<label for="">Sections with items</label>
								<div>
									<!-- Data -->
								</div>
							</div>
						</section>
						<section class="col-12 col-sm-9">
							<section class="form-group sections">
								<label for="">Sections</label>
								<section class="user-sections">
									<div>
										<!-- Data -->
									</div>
								</section>
							</section>
						</section>
					</section>
				</section>
				<!-- Activity -->
				<section class="tabcontent hide-category" id="activity">
					<div class="table-responsive admin-dashboard-table">
						<table class="table table-hover">
							<thead>
							<tr>
								<th scope="col">Action</th>
								<th scope="col">Time</th>
								<th scope="col">User</th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td>
									<!-- Data -->
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</section>
			</section>
		</section>
	</section>
</div>
